<rav-header [masterProducts]="masterProducts" [territories]="territories" [misc]="misc"></rav-header>
<router-outlet></router-outlet>
<rav-footer [masterProducts]="masterProducts" [territories]="territories" [misc]="misc"></rav-footer>
